import { ScriptMap } from "./tools";

/**
 * Defines the interface that exposes all exported scripts in this project.
 */
export interface ISceneScriptMap {
	"src/scenes/cameraControll.ts": ScriptMap;
	"src/scenes/PlayFloatingAndSpinAnimation.ts": ScriptMap;
	"src/scenes/PlayFloatingAnimation.ts": ScriptMap;
}

/**
 * Defines the map of all available scripts in the project.
 */
export const scriptsMap: ISceneScriptMap = {
	"src/scenes/cameraControll.ts": require("./cameraControll"),
	"src/scenes/PlayFloatingAndSpinAnimation.ts": require("./PlayFloatingAndSpinAnimation"),
	"src/scenes/PlayFloatingAnimation.ts": require("./PlayFloatingAnimation"),
}
